<template>
  <div class="batch-delivery-map" style="padding-bottom: 2px">
    <div class="map-wrapper">
      <div id="batch-delivery-map" class="map">
        <div class="leaflet-bottom leaflet-right">
          <a
            class="button has-text-dark"
            style="padding: 10px; margin: 5px; pointer-events: auto"
            @click="fitBounds"
          >
            <i class="fa fa-expand" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
// import geo from "@/geo";
import L from "leaflet";
import "leaflet.locatecontrol";
// import "leaflet-edgebuffer";
import "leaflet.awesome-markers";

export default {
  name: "BatchDeliveryMap",
  components: {},
  data() {
    return {
      uniqueMapID: "batch-delivery-map",
      map: undefined,
      marker: undefined,
      locateControl: undefined,
      stateLayer: undefined,
    };
  },
  computed: {
    business() {
      if (this.$store.getters.getDeliveryDispatcherRole) {
        return this.$store.getters.getDeliveryDispatcherRole.business;
      }
      return null;
    },
    businessName() {
      if (this.business) return this.business.name;
      return null;
    },
    businessType() {
      if (this.business) return this.business.business_type;
      return null;
    },
    businessMap() {
      if (!this.business) return null;
      var lat = this.business.lat;
      var lon = this.business.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
  },
  created() {
    L.AwesomeMarkers.Icon.prototype.options.prefix = "fa";
  },
  mounted() {
    this.initMap();
    EventBus.$on("UPDATE_BATCH_DELIVERY_MAP", () => {
      if (this.stateLayer) this.stateLayer.clearLayers();
      this.drawMarkers();
    });
    // EventBus.$on("SELECT_BATCH_ORDER", ref => {
    //   console.log("SELECT BATCH ORDER map", ref);
    // });
    EventBus.$on("OPEN_BATCH_DELIVERY_MAP", () => {
      this.map.invalidateSize();
      // this.map.flyToBounds(this.stateLayer.getBounds());
      this.map.fitBounds(this.stateLayer.getBounds());
    });
  },
  methods: {
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps

      this.map = L.map(this.uniqueMapID, {
        attributionControl: false,
        doubleClickZoom: true,
      });

      L.tileLayer(tilesURL, {
        // edgeBufferTiles: 1,
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 3,
        maxZoom: 19,
      }).addTo(this.map);
      this.map.invalidateSize();
      this.stateLayer = L.featureGroup().addTo(this.map);
      this.setupLocateControl();

      this.drawMarkers();
    },
    fitBounds() {
      this.map.fitBounds(this.stateLayer.getBounds());
    },
    drawMarkers() {
      this.drawBusinessMarker();
      this.drawOrders();
      // this.map.flyToBounds(this.stateLayer.getBounds());
    },
    drawBusinessMarker() {
      var icon = L.AwesomeMarkers.icon({
        icon: "store-alt",
        markerColor: "blue",
      });
      var coords = { lat: this.business.lat, lng: this.business.lon };
      this.marker = L.marker(coords, { icon: icon }).addTo(this.stateLayer);
      var opts = { closeButton: false, autoPan: false };
      this.marker.bindPopup(this.businessName, opts);
      this.map.setView(coords, 13); // set zoom level 13
    },
    drawOrders() {
      var orders = this.$store.state.batchOrders;
      if (!orders) return;
      orders.forEach((o) => this.drawOrderMarker(o));
    },
    coloredIcon(o) {
      return L.divIcon({
        html: `<div class="delivery-stop dot${o.vehicle}">${o.ref}</div>`,
        popupAnchor: [7, -6],
        className: "none",
      });
    },
    drawOrderMarker(o) {
      if (!o.dropoff) return;
      // default black icon if order vehicle not yet set
      var icon = L.divIcon({
        html: `<div class='delivery-stop'>${o.ref}</div>`,
        popupAnchor: [7, -6],
        className: "none",
      });
      console.log("drawOrder", o.vehicle, this.coloredIcon(o));
      if (o.vehicle > -1) icon = this.coloredIcon(o);
      var coords = { lat: o.dropoff.lat, lng: o.dropoff.lon };
      var m = L.marker(coords, { icon: icon, draggable: true });
      m.addTo(this.stateLayer);
      m.on("click", (e) => {
        this.console("clicked dot", e);
        EventBus.$emit("SELECT_BATCH_ORDER", o.ref);
      });
      var opts = { closeButton: false, autoPan: false };
      var name = `<div style="font-size:1.2em">${o.dropoff.name}</div>`;
      m.bindPopup(name, opts);
      // hide vehicle choosing menu when popup closes
      m.getPopup().on("remove", () => EventBus.$emit("DESELECT_BATCH_ORDER"));
      // scroll bottom to show full map
      // this.map.on("click", () => EventBus.$emit("BATCH_SCROLL_BOTTOM"));
      // this.map.on("dragstart", () => EventBus.$emit("BATCH_SCROLL_BOTTOM"));
    },
    setupLocateControl() {
      var clickBehavior = {
        inView: "setView",
        outOfView: "inView", //"setView",
        inViewNotFollowing: "inView",
      };
      var options = {
        position: "topright",
        icon: "fa fa-crosshairs",
        enableHighAccuracy: true,
        keepCurrentZoomLevel: true,
        flyTo: true,
        showPopup: true,
        drawCircle: false,
        drawMarker: true, // false for driver only
        showCompass: true, // false for driver only
        clickBehavior: clickBehavior,
        onLocationError: (err) => console.warn("locateControl", err),
      };
      this.locateControl = L.control.locate(options).addTo(this.map);
      //   this.locateControl.start(); // centers map to user geolocation
    },
  },
};
</script>

<style scoped>
.map-wrapper {
  /* height: calc(100vh - 100px); */
  height: calc(100vh - 100px);
  width: 100%;
}
.map {
  position: relative;
  height: 100%;
  width: 100vw;
  border: 1px solid #209cee;
  border-radius: 5px;
  z-index: 1;
}
</style>

<style>
.delivery-stop {
  /* margin-top: 10px; */
  font-size: 15px;
  font-weight: bold;
  color: white;
  text-shadow: 1px 1px 3px black;

  height: 26px;
  width: 26px;
  opacity: 0.8;

  border-radius: 50%;
  filter: drop-shadow(1px 1px 1px #555);
  background-color: black;
  opacity: 0.9;
  border-style: solid;
  border-width: 1px;
  border-color: darkslategrey;
}
.leaflet-popup-content {
  padding: 5px 5px;
  margin: 1px 0;
  color: rgb(62, 77, 77);
  /* color: #209cee; */
}
.leaflet-bar a,
.leaflet-bar a:hover {
  text-decoration: none !important;
}
/* colored dots corresponding to vehicle colors, start from 0 */
.dot0 {
  background-color: #1f78b4;
}
.dot1 {
  background-color: #33a02c;
}
.dot2 {
  background-color: #e31a1c;
}
.dot3 {
  background-color: #ff7f00;
}
.dot4 {
  background-color: #a6cee3;
}
.dot5 {
  background-color: #b2df8a;
}
.dot6 {
  background-color: #fb9a99;
}
.dot7 {
  background-color: #fdbf6f;
}
</style>